/**
 * 동양 약어 단위 글리프 카탈로그 (SSoT). 10^4-base — index 0 = 만(10^4), index 16 = 무량대수(10^68).
 * 네 언어 모두 길이 17 고정 (rebasing 로직은 MyriadDisplayMode가 공유, 글자만 다름).
 * 한국어가 1차 타깃. 일/중은 구조 차용 — 글자 정확도는 해당 언어 추가 시 검수.
 */

/** 한국어: 만·억·조·경·해·자·양·구·간·정·재·극 + 불교 단위 5종. */
export const KO_MYRIAD: readonly string[] = [
  "만", "억", "조", "경", "해", "자", "양", "구", "간", "정", "재", "극",
  "항하사", "아승기", "나유타", "불가사의", "무량대수",
];

/** 일본어. */
export const JA_MYRIAD: readonly string[] = [
  "万", "億", "兆", "京", "垓", "𥝱", "穣", "溝", "澗", "正", "載", "極",
  "恒河沙", "阿僧祇", "那由他", "不可思議", "無量大数",
];

/** 중국어 간체. */
export const ZH_HANS_MYRIAD: readonly string[] = [
  "万", "亿", "兆", "京", "垓", "秭", "穰", "沟", "涧", "正", "载", "极",
  "恒河沙", "阿僧祇", "那由他", "不可思议", "无量大数",
];

/** 중국어 번체. */
export const ZH_HANT_MYRIAD: readonly string[] = [
  "萬", "億", "兆", "京", "垓", "秭", "穰", "溝", "澗", "正", "載", "極",
  "恆河沙", "阿僧祇", "那由他", "不可思議", "無量大數",
];

/** locale → 동양 단위 테이블. 미지원 동아시아 변형은 한국어 fallback. */
export function myriadUnitsFor(locale: string | undefined): readonly string[] {
  const lc = (locale ?? "").toLowerCase();
  if (lc.startsWith("ja")) return JA_MYRIAD;
  if (lc.startsWith("zh-hant") || lc === "zh-tw" || lc === "zh-hk") return ZH_HANT_MYRIAD;
  if (lc.startsWith("zh")) return ZH_HANS_MYRIAD;
  return KO_MYRIAD;
}

/** 동아시아 언어 여부 (locale 자동 표기 분기). */
export function isEastAsianLocale(locale: string | undefined): boolean {
  const lc = (locale ?? "").toLowerCase();
  return lc.startsWith("ko") || lc.startsWith("ja") || lc.startsWith("zh");
}
